import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function CurriculumPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 커리큘럼 - 수학·영어·국어';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '민락, 옥정, 지행 미래인재학원 과목별 커리큘럼. 수학, 영어, 국어, 과학 전 과목 체계적인 입시 대비 프로그램을 제공합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 커리큘럼 - 수학 영어 국어 과학 입시 교육');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '민락, 옥정, 지행 미래인재학원 과목별 커리큘럼. 수학, 영어, 국어, 과학 전 과목 체계적인 입시 대비 프로그램을 제공합니다.');
    }
  }, []);

  const subjects = [
    {
      id: 'math',
      name: '수학',
      icon: 'ri-calculator-line',
      color: 'from-rose-500 to-red-600',
      description: '수학적 사고력과 문제 해결 능력을 키우는 체계적인 커리큘럼',
      levels: [
        {
          level: '기초반',
          target: '개념 정립이 필요한 학생',
          content: ['기본 개념 완벽 정리', '교과서 필수 문제 풀이', '기초 연산 능력 강화', '개념 확인 테스트']
        },
        {
          level: '심화반',
          target: '상위권 도약을 원하는 학생',
          content: ['심화 개념 학습', '고난도 문제 풀이 전략', '수능 기출 분석', '변별력 문제 집중 훈련']
        },
        {
          level: '최상위반',
          target: '1등급 목표 학생',
          content: ['킬러 문항 완벽 대비', '수능 만점 전략', '수리논술 대비', '경시대회 준비']
        }
      ],
      features: ['주 3회 정규 수업', '매일 클리닉 운영', '주간 테스트', '1:1 질의응답']
    },
    {
      id: 'english',
      name: '영어',
      icon: 'ri-english-input',
      color: 'from-emerald-500 to-teal-600',
      description: '독해력과 어휘력을 바탕으로 한 실전 영어 능력 향상',
      levels: [
        {
          level: '기초반',
          target: '영어 기초가 부족한 학생',
          content: ['필수 문법 완성', '기본 어휘 암기', '짧은 지문 독해', '듣기 기초 훈련']
        },
        {
          level: '심화반',
          target: '2등급 이상 목표 학생',
          content: ['고급 문법 학습', '빈칸 추론 전략', '장문 독해 훈련', '어법 집중 학습']
        },
        {
          level: '최상위반',
          target: '1등급 목표 학생',
          content: ['EBS 연계 완벽 분석', '고난도 빈칸 공략', '순서/삽입 문제 전략', '시간 단축 훈련']
        }
      ],
      features: ['원어민 발음 훈련', '매일 단어 테스트', '모의고사 분석', '오답 클리닉']
    },
    {
      id: 'korean',
      name: '국어',
      icon: 'ri-book-2-line',
      color: 'from-amber-500 to-orange-600',
      description: '문학과 비문학을 아우르는 종합적인 국어 능력 배양',
      levels: [
        {
          level: '기초반',
          target: '국어 기본기가 부족한 학생',
          content: ['문법 기초 완성', '문학 개념어 학습', '짧은 지문 분석', '어휘력 강화']
        },
        {
          level: '심화반',
          target: '안정적인 2등급 목표',
          content: ['비문학 독해 전략', '문학 작품 심층 분석', '화법과 작문', '언어와 매체']
        },
        {
          level: '최상위반',
          target: '1등급 및 논술 대비',
          content: ['고난도 비문학 공략', '문학 감상 심화', '수능 실전 모의고사', '논술 기초 훈련']
        }
      ],
      features: ['지문 분석 훈련', '배경지식 특강', '첨삭 지도', '기출 분석']
    },
    {
      id: 'science',
      name: '과학',
      icon: 'ri-flask-line',
      color: 'from-sky-500 to-cyan-600',
      description: '물리, 화학, 생명과학, 지구과학 전 영역 완벽 대비',
      levels: [
        {
          level: '기초반',
          target: '과학 개념 정립이 필요한 학생',
          content: ['핵심 개념 정리', '기본 문제 풀이', '실험 원리 이해', '그래프 해석 기초']
        },
        {
          level: '심화반',
          target: '2등급 이상 목표 학생',
          content: ['심화 개념 학습', '자료 분석 능력 강화', '복합 문제 풀이', '오개념 교정']
        },
        {
          level: '최상위반',
          target: '1등급 및 의대 목표',
          content: ['킬러 문항 대비', '고난도 자료 해석', '시간 단축 전략', '실전 모의고사']
        }
      ],
      features: ['과목별 전문 강사', '개념 영상 제공', '단원별 테스트', '질의응답 시간']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="curriculum" />
      
      {/* Hero Section */}
      <section className="pt-20 relative min-h-[500px] flex items-center">
        <div className="absolute inset-0 bg-black">
          <img 
            src="https://public.readdy.ai/ai/img_res/d41d615cd2bf8b5a686d4042d84cd1a6.jpg"
            alt="커리큘럼 배경"
            className="w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="max-w-2xl">
            <div className="inline-block px-4 py-2 bg-amber-500/20 border border-amber-500/30 rounded-full mb-6">
              <span className="text-amber-400 text-sm font-medium">Curriculum</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              미래인재학원<br /><span className="text-amber-400">커리큘럼</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-6 leading-relaxed">
              수준별 맞춤 교육으로 확실한 성적 향상을 보장합니다<br />
              수학 1등급, 영어 1등급, 국어 1등급, 과학 1등급 전 과목 완벽 대비
            </p>
            <div className="flex flex-wrap gap-3">
              {subjects.map((subject) => (
                <a 
                  key={subject.id}
                  href={`#${subject.id}`}
                  className="px-4 py-2 bg-white/10 hover:bg-amber-500 text-white hover:text-black rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
                >
                  {subject.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Subject Sections */}
      {subjects.map((subject, index) => (
        <section 
          key={subject.id} 
          id={subject.id}
          className={`py-20 px-4 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-950'}`}
        >
          <div className="max-w-7xl mx-auto">
            {/* Subject Header */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-12">
              <div className="flex items-center gap-4">
                <div className={`w-16 h-16 bg-gradient-to-br ${subject.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${subject.icon} text-3xl text-white`}></i>
                </div>
                <div>
                  <h2 className={`text-3xl md:text-4xl font-bold ${index % 2 === 0 ? 'text-gray-900' : 'text-white'}`}>
                    {subject.name}
                  </h2>
                  <p className={`text-sm ${index % 2 === 0 ? 'text-gray-600' : 'text-gray-400'}`}>
                    {subject.description}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {subject.features.map((feature, idx) => (
                  <span 
                    key={idx}
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      index % 2 === 0 
                        ? 'bg-amber-100 text-amber-700' 
                        : 'bg-amber-500/20 text-amber-400'
                    }`}
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>

            {/* Level Cards */}
            <div className="grid md:grid-cols-3 gap-6">
              {subject.levels.map((level, levelIdx) => (
                <div 
                  key={levelIdx}
                  className={`rounded-2xl overflow-hidden ${
                    index % 2 === 0 
                      ? 'bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-700' 
                      : 'bg-white border border-gray-200'
                  } hover:shadow-xl transition-shadow`}
                >
                  <div className={`p-6 bg-gradient-to-r ${subject.color}`}>
                    <div className="flex items-center justify-between">
                      <h4 className="text-xl font-bold text-white">{level.level}</h4>
                      <span className="px-3 py-1 bg-white/20 rounded-full text-xs text-white font-medium">
                        Level {levelIdx + 1}
                      </span>
                    </div>
                    <p className="text-sm text-white/80 mt-2">{level.target}</p>
                  </div>
                  <div className="p-6">
                    <h5 className={`text-sm font-semibold mb-4 ${
                      index % 2 === 0 ? 'text-amber-400' : 'text-gray-900'
                    }`}>
                      학습 내용
                    </h5>
                    <ul className="space-y-3">
                      {level.content.map((item, itemIdx) => (
                        <li 
                          key={itemIdx}
                          className={`flex items-start gap-3 text-sm ${
                            index % 2 === 0 ? 'text-gray-300' : 'text-gray-600'
                          }`}
                        >
                          <i className={`ri-checkbox-circle-fill mt-0.5 ${
                            index % 2 === 0 ? 'text-amber-500' : 'text-amber-600'
                          }`}></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-amber-600 via-amber-500 to-yellow-500">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-black mb-6">
            나에게 맞는 커리큘럼이<br />궁금하신가요?
          </h3>
          <p className="text-lg text-black/80 mb-8">
            무료 레벨 테스트와 상담을 통해 최적의 학습 계획을 세워드립니다
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="px-8 py-4 bg-black text-white rounded-lg font-semibold hover:bg-gray-900 transition-colors shadow-lg whitespace-nowrap cursor-pointer text-center">
              홈으로 돌아가기
            </Link>
            <Link to="/contact" className="px-8 py-4 bg-white text-black rounded-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer text-center">
              무료 상담 신청
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
